/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/Quote/CartTools.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'QuoteModal': {
            Fields: [
                {
                    "Name": 'Quote Name',
                    "Field": '#txtQuoteName',
                    "Type": 'Text'
                }
            ],
            Validate: true,
            ErrorMsg: 'Please enter a quote name'
        }
    };

    return forms;
});
